import { useTranslation } from 'react-i18next';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { DashboardStatsGrid } from '@/features/dashboard/components/DashboardStatsGrid';
import { DashboardChartCard } from '@/features/dashboard/components/DashboardChartCard';
import { useDashboardSummaryQuery } from '@/features/dashboard/hooks/use-dashboard';
import { formatUpdatedAt } from '@/features/dashboard/utils/format-updated-at';

export function AdminHomePage() {
  const { t } = useTranslation('admin');
  // PRD 01 §7 / §1.2 — DASHBOARD:READ gates the page; DASHBOARD:NO_PERMISSION roles are
  // bounced to /home with a notice (Root always passes via useCan's isRoot short-circuit).
  const canRead = useRequirePermission('DASHBOARD', 'READ');
  // Update time comes from the summary payload (data field), NOT the client clock.
  // Same query key as DashboardStatsGrid → react-query dedupes to a single fetch.
  const { data: summary } = useDashboardSummaryQuery();
  const updatedAt = formatUpdatedAt(summary?.updatedAt);

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('dashboard.title')}</h1>
          {updatedAt ? (
            <p className="dashboard__update-time">{t('dashboard.updated', { time: updatedAt })}</p>
          ) : null}
        </div>
      </div>
      <div className="content__body">
        <DashboardStatsGrid />

        <div className="dashboard__charts-grid">
          <DashboardChartCard which="patientsByDepartment" />
          <DashboardChartCard which="inquiryStatus" />
        </div>
      </div>
    </>
  );
}
